var map = {
	"./2couch3.svg": [
		57230,
		57230
	],
	"./airConditioner.svg": [
		37173,
		37173
	],
	"./airConditionerMobile.svg": [
		4403,
		4403
	],
	"./armchair.svg": [
		88566,
		88566
	],
	"./armchair2.svg": [
		29240,
		29240
	],
	"./armchairs.svg": [
		51049,
		51049
	],
	"./art.svg": [
		7782,
		7782
	],
	"./bar.svg": [
		16150,
		16150
	],
	"./basicKitchenEquipment.svg": [
		27347,
		27347
	],
	"./bath.svg": [
		92320,
		92320
	],
	"./bbq.svg": [
		90940,
		90940
	],
	"./beachUmbrella.svg": [
		23836,
		23836
	],
	"./bedFolding.svg": [
		39735,
		39735
	],
	"./bedKing.svg": [
		23481,
		23481
	],
	"./bedQueen.svg": [
		18266,
		18266
	],
	"./billard.svg": [
		53291,
		53291
	],
	"./boardGames.svg": [
		45194,
		45194
	],
	"./brasero.svg": [
		18033,
		18033
	],
	"./breakfast.svg": [
		54114,
		54114
	],
	"./buoy.svg": [
		76476,
		76476
	],
	"./cleaner.svg": [
		11907,
		11907
	],
	"./cleaning.svg": [
		20014,
		20014
	],
	"./coatHanger.svg": [
		79799,
		79799
	],
	"./coffeeMaker.svg": [
		90185,
		90185
	],
	"./convertibleSofa.svg": [
		51133,
		51133
	],
	"./couch12.svg": [
		13926,
		13926
	],
	"./couch4.svg": [
		14337,
		14337
	],
	"./couch6.svg": [
		81987,
		81987
	],
	"./couch9.svg": [
		24948,
		24948
	],
	"./dishes10.svg": [
		64512,
		64512
	],
	"./dishes24.svg": [
		15861,
		15861
	],
	"./dishwasher.svg": [
		35451,
		35451
	],
	"./dryTowel.svg": [
		42159,
		42159
	],
	"./dryer.svg": [
		10627,
		10627
	],
	"./fence.svg": [
		70930,
		70930
	],
	"./foodProcessor.svg": [
		97257,
		97257
	],
	"./footBed.svg": [
		43448,
		43448
	],
	"./freezer.svg": [
		47824,
		47824
	],
	"./fridge.svg": [
		90484,
		90484
	],
	"./fryer.svg": [
		93789,
		93789
	],
	"./gardenLounge.svg": [
		40706,
		40706
	],
	"./hairDryer.svg": [
		62095,
		62095
	],
	"./hanger.svg": [
		63950,
		63950
	],
	"./heating.svg": [
		72031,
		72031
	],
	"./hectare.svg": [
		87843,
		87843
	],
	"./iceMaker.svg": [
		1416,
		1416
	],
	"./inductionCooker.svg": [
		56905,
		56905
	],
	"./iron.svg": [
		42681,
		42681
	],
	"./kettle.svg": [
		27166,
		27166
	],
	"./largeCouch2.svg": [
		74344,
		74344
	],
	"./microwave.svg": [
		88582,
		88582
	],
	"./multiSport.svg": [
		34572,
		34572
	],
	"./outdoorDining.svg": [
		94002,
		94002
	],
	"./oven.svg": [
		49513,
		49513
	],
	"./parking.svg": [
		39317,
		39317
	],
	"./pingPong.svg": [
		72321,
		72321
	],
	"./pizzaOven.svg": [
		35913,
		35913
	],
	"./play4.svg": [
		81647,
		81647
	],
	"./play5.svg": [
		45246,
		45246
	],
	"./portal.svg": [
		89193,
		89193
	],
	"./sauna.svg": [
		13543,
		13543
	],
	"./seaWater.svg": [
		42665,
		42665
	],
	"./shampoo.svg": [
		24674,
		24674
	],
	"./sheets.svg": [
		55259,
		55259
	],
	"./shower.svg": [
		86473,
		86473
	],
	"./shutters.svg": [
		37529,
		37529
	],
	"./shuttersManual.svg": [
		91591,
		91591
	],
	"./shuttersManualAndElectric.svg": [
		99,
		99
	],
	"./slicer.svg": [
		17779,
		17779
	],
	"./smokeDetector.svg": [
		35560,
		35560
	],
	"./soap.svg": [
		48242,
		48242
	],
	"./speaker.svg": [
		98238,
		98238
	],
	"./sunTowels.svg": [
		71263,
		71263
	],
	"./sunbeds.svg": [
		2675,
		2675
	],
	"./swimmingPoolShutters.svg": [
		57300,
		57300
	],
	"./table.svg": [
		42701,
		42701
	],
	"./table10.svg": [
		87946,
		87946
	],
	"./table12.svg": [
		48552,
		48552
	],
	"./tableSmall.svg": [
		68234,
		68234
	],
	"./tableSmall3.svg": [
		10197,
		10197
	],
	"./tableSmallWork.svg": [
		22449,
		22449
	],
	"./toaster.svg": [
		96469,
		96469
	],
	"./towels.svg": [
		52139,
		52139
	],
	"./tree.svg": [
		89999,
		89999
	],
	"./tv48.svg": [
		32985,
		32985
	],
	"./tv65.svg": [
		56326,
		56326
	],
	"./tv75.svg": [
		39637,
		39637
	],
	"./tv78.svg": [
		85648,
		85648
	],
	"./tv85.svg": [
		59136,
		59136
	],
	"./wardrobe.svg": [
		20575,
		20575
	],
	"./washingMachine.svg": [
		67209,
		67209
	],
	"./waterPurifier.svg": [
		24940,
		24940
	],
	"./wc.svg": [
		82173,
		82173
	],
	"./wcSeparate.svg": [
		32982,
		32982
	],
	"./wifi.svg": [
		22632,
		22632
	],
	"./wine.svg": [
		45332,
		45332
	],
	"./wineCellar.svg": [
		43545,
		43545
	],
	"./woodStove.svg": [
		81375,
		81375
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 38187;
module.exports = webpackAsyncContext;